//* react
import React from 'react';

interface UnreadUsersPreviewProps {
  menuItemId: string | undefined;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const UnreadUsersPreview: React.FC<UnreadUsersPreviewProps> = () => {
  // Component is kept empty as the API now returns only counts, not user lists
  return null;
};

export default UnreadUsersPreview;
